import { ScheduleProvider } from "../hooks/useSchedule";
import { ScheduleDisplay } from "../components/ScheduleDisplay";

export function Schedule() {
  return (
    <ScheduleProvider>
      <ScheduleDisplay />
    </ScheduleProvider>
  );
}
